


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { Package } from '../../types/payment';

@Component
export default class PackageSelectionRegister extends Vue {
  @Prop() onSelected!: (selectedPackage: Package) => {};
  @Prop({ default: 'primary' }) subjectColor!: string;

  selectPackage(selectedPackage: Package) {
    this.onSelected(selectedPackage);
  }
}
